import page from './index';

export default {
    path: '/home/tiger/active-history',
    meta: { titie: '活跃委托历史' },
    component: page,
}
